import { render, staticRenderFns } from "./UrnSalesFormView.vue?vue&type=template&id=610b640a&"
import script from "./UrnSalesFormView.vue?vue&type=script&lang=js&"
export * from "./UrnSalesFormView.vue?vue&type=script&lang=js&"
import style0 from "./UrnSalesFormView.vue?vue&type=style&index=0&id=610b640a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports